export default "__VITE_ASSET__Cy5nJa0G__"